// extracted by mini-css-extract-plugin
export default {"wrapper":"MusicKind_wrapper__880pC","item":"MusicKind_item__EBcAF","list":"MusicKind_list__fXJVu","image":"MusicKind_image__S2-NB","title":"MusicKind_title__Umvj3"};